import { computed } from "vue";
import type { SkeletonProps } from "./skeleton.types";
import { SKELETON_VARIANTS } from "./skeleton.types";
import { useSharedState } from "composables/useSharedState";
import { skeletonClasses } from "./skeleton.styles";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import { parseBoolAttr } from "@/runtime/shared/attrs";

export interface UseSkeletonOptions {
  props: Readonly<SkeletonProps>;
}

export const useSkeleton = (options: UseSkeletonOptions) => {
  const { props } = options;
  const state = useSharedState(props);

  const variant = computed(() => {
    const v = state.variant?.value;
    return (SKELETON_VARIANTS as readonly string[]).includes(v as string) ? (v as SkeletonProps["variant"]) : "line";
  });

  const animated = computed(() => parseBoolAttr(state.animated?.value as boolean | string | undefined, true));

  const classes = computed(() =>
    mergeClassProp(
      skeletonClasses({ variant: variant.value, animated: animated.value ? "true" : "false" }),
      props.class,
    ),
  );

  return { classes };
};
